import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReviewsPage from "./pages/ReviewsPage";
import ContentPage from "./pages/ContentPage";
import SubmitReviewPage from "./pages/SubmitReviewPage";
import CompanyListPage from "./pages/CompanyListPage";
import AuthPage from "./pages/AuthPage";
import { PAGES } from "./pages/pageContent";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function StaticRoute() {
  const { pathname } = useLocation();
  const page = PAGES[pathname];
  if (!page) {
    return (
      <ContentPage
        title="Page coming soon"
        subtitle="We're still building this section. Check back shortly."
        breadcrumb={[{ label: "Home", to: "/" }, { label: "Not built yet" }]}
        sections={[{ heading: "In the meantime", body: "Why not browse company reviews, submit a review, or read our consumer guides?" }]}
      />
    );
  }
  return <ContentPage {...page} />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop/>
        <Routes>
          {/* Homepage is now Browse Companies */}
          <Route path="/" element={<CompanyListPage />} />
          <Route path="/browse" element={<CompanyListPage />} />

          {/* Every company (including Evri) lives at /company/:slug */}
          <Route path="/company/:slug" element={<ReviewsPage />} />

          {/* Functional pages */}
          <Route path="/submit-review" element={<SubmitReviewPage />} />
          <Route path="/signin" element={<AuthPage mode="signin" />} />
          <Route path="/signup" element={<AuthPage mode="signup" />} />

          {/* Static content pages */}
          {Object.keys(PAGES).map((p) => (
            <Route key={p} path={p} element={<StaticRoute />} />
          ))}

          {/* Catch-all */}
          <Route path="*" element={<StaticRoute />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
